@for (block of finalBlock; track block) {
  <div>
    @switch (block.type) {
      @case ('header-one') {
        <h1>
          @for (text of block.content; track text) {
            <app-block-item [text]="text" (stepChange)="handleStepChange($event)"></app-block-item>
          }
        </h1>
      }
      @case ('header-two') {
        <h2>
          @for (text of block.content; track text) {
            <app-block-item [text]="text" (stepChange)="handleStepChange($event)"></app-block-item>
          }
        </h2>
      }
      @case ('header-three') {
        <h3>
          @for (text of block.content; track text) {
            <app-block-item [text]="text" (stepChange)="handleStepChange($event)"></app-block-item>
          }
        </h3>
      }
      @case ('header-four') {
        <h4>
          @for (text of block.content; track text) {
            <app-block-item [text]="text" (stepChange)="handleStepChange($event)"></app-block-item>
          }
        </h4>
      }
      @case ('ordered-list') {
        <ol>
          @for (item of block.content; track item) {
            <li>
              @for (text of item; track text) {
                <span>
                  <app-block-item [text]="text" (stepChange)="handleStepChange($event)"></app-block-item>
                </span>
              }
            </li>
          }
        </ol>
      }
      @case ('unordered-list') {
        <ul>
          @for (item of block.content; track item) {
            <li>
              @for (text of item; track text) {
                <span>
                  <app-block-item [text]="text" (stepChange)="handleStepChange($event)"></app-block-item>
                </span>
              }
            </li>
          }
        </ul>
      }
      @default {
        <div>
          @for (text of block.content; track text) {
            <app-block-item [text]="text" (stepChange)="handleStepChange($event)"></app-block-item>
          }
        </div>
      }
    }
  </div>
}
